import { beta1Links, betaLinks, developmentLinks, productionLinks, qaLinks, stageLinks } from '@local/utils'

import { PHASE } from '..'
import commonLinks from './common'

const phaseLinks =
  {
    qa: qaLinks,
    development: developmentLinks,
    production: productionLinks,
    stage: stageLinks,
    beta: betaLinks,
    beta1: beta1Links,
  }[PHASE] ?? developmentLinks

const links = {
  ...phaseLinks,
  ...commonLinks,
} as const

export default links
